// Identity, navigation and contact points. Single source of truth for anything
// that appears in more than one view.

const SITE = {
	name: "Anjanava Biswas",
	nameLines: ["Anjanava", "Biswas"],
	title: "Anjanava Biswas · Applied AI Architecture",
	location: "San Diego, California",
	email: "anjan.biswas@ieee.org",
	// scholar: "https://scholar.google.com/citations?user=DCMJsJ4AAAAJ&hl=en",
	github: "https://github.com/anjanvb",
	// Default theme for a first-time visitor. Persisted under this key.
	defaultTheme: "dark",
	themeStorageKey: "ab-theme-v2",
};

// Five destinations, in header order.
const NAV = [
	{ label: "Home", path: "/" },
	{ label: "Practice", path: "/practice" },
	{ label: "Publications", path: "/publications" },
	{ label: "Recognition", path: "/recognition" },
	{ label: "About", path: "/about" },
];

// Footer icon buttons. `icon` maps to a react-icons/fa6 component in footer.jsx.
const SOCIALS = [
	{
		icon: "linkedin",
		label: "LinkedIn",
		link: "https://linkedin.com/in/anjanavabiswas",
	},
	{ icon: "x", label: "X", link: "https://twitter.com/itsrealAJB" },
	{
		icon: "stackoverflow",
		label: "Stack Overflow",
		link: "https://stackoverflow.com/users/1137672/anjan-biswas",
	},
	// {
	// 	icon: "scholar",
	// 	label: "Google Scholar",
	// 	link: "https://scholar.google.com/citations?user=DCMJsJ4AAAAJ&hl=en",
	// },
	{ icon: "github", label: "GitHub", link: "https://github.com/anjanvb" },
	{ icon: "email", label: "Email", link: "mailto:anjan.biswas@ieee.org" },
];

export { SITE, NAV, SOCIALS };
